/**************************************************
 * Nombre:       Tarjeta_Resultados_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Grafica_Funnel from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Grafica_Funnel";
import Barra_Vertical_Limpia_Funnel from "../../Modulo_Graficas/Graficas/Barra_Vertical_Limpia_Funnel";
import {BORDER} from "../../Modulo_Graficas/ContantesColorGraficas";
import {TEXTO, TEXTOCLARO} from "../../Modulo_Dashboard/ContantesColor";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {useContext} from "react";
import {usuarioContext} from "../../App";

const Tarjeta_Resultados_Funnel = ({item,  global = false, datos, series}) => {
    const cData = useContext(usuarioContext)

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
            sx={{
                border: BORDER,
                borderRadius: 2,
                p: 1
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Tarjeta_Grafica_Funnel
                    height={350}
                    Grafica={Barra_Vertical_Limpia_Funnel}
                    titulo={item.nombreFunnel}
                    series={series}
                    subtitulo={global ? `Resultados Globales` : `Campañas ${cData.usuario.nombres}`}
                />
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 4}}
                sx={{mt: 2, color: TEXTO}}
                spacing={0}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: TEXTOCLARO, fontSize: 14, fontWeight: 400}}>Inversion Total</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontSize: 24,
                        fontWeight: 800,
                        lineHeight: 1.2
                    }}>{formatoMonedaTabla(datos.valorTotal)}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: TEXTOCLARO, fontSize: 14, fontWeight: 400}}>Lead Calificados</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 24, fontWeight: 800, lineHeight: 1.2}}>{datos.calificados}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Typography sx={{color: TEXTOCLARO, fontSize: 12, fontWeight: 400}}>Lead Captados</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontSize: 19, fontWeight: 700, lineHeight: 1.2}}>{datos.captados}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{color: TEXTOCLARO, fontSize: 12, fontWeight: 400}}>Lead Alimentandose</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontSize: 19, fontWeight: 700, lineHeight: 1.2}}>{datos.alimentandose}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{color: TEXTOCLARO, fontSize: 12, fontWeight: 400}}>Lead calificados</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontSize: 19, fontWeight: 700, lineHeight: 1.2}}>{datos.calificados}</Typography>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Resultados_Funnel